module.exports = __webpack_public_path__ + "img/img-top.516f3127.jpg";